export default "__VITE_ASSET__DbSF5Ta___"